import { getEnvironmentConfig, getEnvVariableDefault, getFeatureBranchPrefix } from '../configHelper.js';
const definition = {
    base: {
        cpServiceUrl: '',
        sentry: {
            dsn: 'https://b9b5c583de3249d79dd0718e30c7a4bf@o4504712601862144.ingest.sentry.io/4504722549374976',
            debug: false,
        },
        redis: {
            url: getEnvVariableDefault('REDIS_URL', ''),
        },
    },
    local: {
        cpServiceUrl: 'http://localhost:4001',
        redis: {
            url: 'redis://localhost:6379',
        },
    },
    local_k8s: {
        cpServiceUrl: 'http://localhost:4001',
        redis: {
            url: 'redis://editor-redis:6379',
        },
    },
    local_e2e: {
        cpServiceUrl: 'http://localhost:4001',
        redis: {
            url: 'redis://redis:6379',
        },
    },
    test: {
        cpServiceUrl: 'http://localhost:4001',
    },
    development: {
        cpServiceUrl: 'https://ctf-cp2.bf-ctf-development.aws.bfops.io',
    },
    sandbox: {
        cpServiceUrl: `https://${getFeatureBranchPrefix()}ctf-cp2.bf-ctf-sandbox.aws.bfops.io`,
    },
    staging: {
        cpServiceUrl: 'https://ctf-cp2.bf-ctf-staging.aws.bfops.io',
    },
    production: {
        cpServiceUrl: 'https://ctf-cp2.bf-ctf-production.aws.bfops.io',
    },
};
export const cpServiceConfig = () => getEnvironmentConfig(definition);
//# sourceMappingURL=cp.service.config.js.map